'use strict';

import React from 'react'

import _ from 'lodash'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout     from '@Layout/BackOffice'
import UpdateForm from '@/Form/UpdateForm'
import _config    from '@Config/Forms/user'

import Loader from '@Pure/Loader'

let app = window.app;

let config = _.cloneDeep(_config);

config.form_title = 'Modification d\'un utilisateur';

export default class UserPage extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state = { };
	}

	componentWillMount ()
	{
		const component = this;

		app.resetFunctions();

		config.hookGetDataAjax = function (form_data, response)
		{
			component.setState(
			{
				id: response.data.id,
				status: response.data.validation_status
			});
		};
	}

	resendToken = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ loading: true });

		qwest.post('/user/resend-token',
		{
			id: state.id
		})
		.then(function (xhr, response)
		{
			component.setState({ loading: false, info: 'E-mail envoyé.' });
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, xhr, response);
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let resend_token_btn;

		if (state.status === 'new')
		{
			let loader, info;

			if (state.loading === true)
			{
				loader = <Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />;
			}

			if (state.info)
			{
				info =
				(
					<div className="c-message c-message--green u-full-width">
						<div className="c-message__content">
							{ state.info }
						</div>
					</div>
				);
			}

			resend_token_btn =
			(
				<div className="u-full-width u-margin-top-20">
					{ info }

					<button type="button" className="c-btn c-btn--red"
						onClick={ component.resendToken } >
						Renvoyer le lien d'inscription
						{ loader }
					</button>

				</div>
			);
		}

		let output =
		(
			<Layout page_title="Modification d'un utilisateur"
				hide_title={ true } history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<TransitionGroup className="page-form-container">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={{ enter: 240, exit: 320, appear: 500 }}>

								<UpdateForm config={ config } />


							</CSSTransition>

						</TransitionGroup>

						{ resend_token_btn }

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}